const DECIMAL_INPUT_NAV_KEYS = new Set([
  "Backspace",
  "Delete",
  "Tab",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End"
]);

function isDecimalDigitKey(key: string): boolean {
  return key.length === 1 && /[0-9]/.test(key);
}

function isDecimalShortcutKey(e: { ctrlKey: boolean; metaKey: boolean; key: string }): boolean {
  if (!e.ctrlKey && !e.metaKey) {
    return false;
  }
  const k = e.key.toLowerCase();
  return k === "a" || k === "c" || k === "x" || k === "z";
}

/** Strips non-numeric characters; allows digits and at most one decimal point. */
export function sanitizeDecimalInput(raw: string): string {
  const cleaned = raw.replace(/[^\d.]/g, "");
  const dotIndex = cleaned.indexOf(".");
  if (dotIndex === -1) {
    return cleaned;
  }
  return cleaned.slice(0, dotIndex + 1) + cleaned.slice(dotIndex + 1).replace(/\./g, "");
}

export function shouldAllowDecimalKeyDown(
  e: { key: string; ctrlKey: boolean; metaKey: boolean },
  currentValue: string
): boolean {
  if (DECIMAL_INPUT_NAV_KEYS.has(e.key)) {
    return true;
  }
  if (isDecimalShortcutKey(e)) {
    return true;
  }
  if (isDecimalDigitKey(e.key)) {
    return true;
  }
  if (e.key === "." && !currentValue.includes(".")) {
    return true;
  }
  return false;
}

export function mergeDecimalPaste(currentValue: string, pastedText: string, start: number, end: number): string {
  return sanitizeDecimalInput(currentValue.slice(0, start) + pastedText + currentValue.slice(end));
}
